import {
  HEALTH_DIARY_FETCH,
  HEALTH_DIARY_FETCH_TYPE,
  HEALTH_DIARY_ADD,
  HEALTH_DIARY_UPDATE,
  HEALTH_DIARY_DELETE,
  AUTH_LOG_OUT_USER,
  TRANSFERS_UPDATE_PET_AND_TRANSFER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetchType: "",
  fetchDates: "",
  lastFetchPetID: "",
};

export default function HealthDiaryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case HEALTH_DIARY_FETCH:
      return {
        ...state,
        entries: _.sortBy(action.payload, "date").reverse(),
        lastFetchPetID: action.pet._id,
      };
    case HEALTH_DIARY_FETCH_TYPE:
      return {
        ...state,
        fetchDates: action.payload.dates,
        fetchType: action.payload.type,
      };
    case HEALTH_DIARY_ADD:
      return {
        ...state,
        entries: _.sortBy([...state.entries, action.payload], "date").reverse(),
        fetchDates: "",
      };
    case HEALTH_DIARY_UPDATE:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "date"
        ).reverse(),
      };
    case HEALTH_DIARY_DELETE:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case TRANSFERS_UPDATE_PET_AND_TRANSFER:
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
